import BaseView from './BaseView';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Slideshow from '../../components/Slideshow';
gsap.registerPlugin(ScrollTrigger);

let view = null;

class Case extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.slideShows = this.container.querySelectorAll('[data-slideshow]');
        this.descriptionButton = this.container.querySelector('[data-case-button]');
		this.description = this.container.querySelector('[data-description]');
        this.descriptionText = this.container.querySelector('[data-case-text]');

		this.header = this.container.querySelector('[data-header-section]');

		this.headerTrigger = new ScrollTrigger({
			trigger: this.header,
			start: 'bottom top',
			markers: false,
			onEnter: () => {
				document.body.classList.add('body__nav--purple');
			},
			onEnterBack: () => {
				document.body.classList.remove('body__nav--purple');
			}
		});

		if (this.descriptionButton) {
			this.descriptionButton.addEventListener('click', () => {
				if (this.description && this.descriptionText.style.maxHeight) {
					this.description.classList.remove("open");
					this.descriptionText.style.opacity = 0;
					this.descriptionText.style.maxHeight = null;
					this.descriptionText.style.marginBottom = "0px";
					this.descriptionButton.ariaExpanded = 'false';
				} else {
					this.descriptionText.style.maxHeight = this.descriptionText.scrollHeight + "px";
					this.descriptionText.style.opacity = 1;
					this.descriptionText.style.marginBottom = "32px";
					this.description.classList.add("open");
					this.descriptionButton.ariaExpanded = 'true';
				}
			});
		}

		this.slideShows.forEach((slideshow) => {
			new Slideshow(slideshow);
		})
    }


	destroy() {
		super.destroy();
		this.headerTrigger.kill();
	}
}

export default {
	namespace: 'single-case',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Case(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};